export default __webpack_public_path__ + "static/next-step-b24047ce7316166bbbdd4c7a6a99c55f.svg";